// import toastStore from '@/stores/toast-store.js';
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import iosSafariButton from '@/assets/images/ios-safari-button.png'
import axios from 'axios'

export default {
  name: 'iOSAddToHomeScreenPropmptModal',
  extends: BaseModal,
  data: function () {
    return {
      iosSafariButton: iosSafariButton,
    }
  },
  mounted() {
    // Registered first time only when user 'ios-safari' user entered app and encountered this modal
    if (JSON.parse(localStorage.getItem('skip_install_app_prompt')) == null) {
      this.updateUserActivity('safari-ios', 'app_instalation', false)
    }
  },
  methods: {
    skipiOSAppPrompt() {
      localStorage.setItem('skip_install_app_prompt', true)
      // when actively skipped, this modal will be shown in future
      this.close(false)
    },

    confirmNotSkippingiOSAppPrompt() {
      localStorage.setItem('skip_install_app_prompt', false)
      this.close(false)
    },

    updateUserActivity(platform, activity, activityValue) {
      const params = {
        userActivity: {
          platform: platform,
          activity: activity,
          activityValue: activityValue,
          metadata: {
            userAgent: window.navigator.userAgent,
          },
        },
      }

      axios({
        method: 'post',
        url: 'user_activities',
        data: params,
      })
        .then(response => {
          console.log('response', response)
        })
        .catch(error => {
          console.error('error updateUserActivity', error)
        })
    },
  },
}
